import {
  profile_card_styles_default
} from "./chunk.UC53YDT5.js";
import {
  jsonAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/profile-card/profile-card.ts
import { t as t2 } from "i18next";
var FadvProfileCard = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlot = new HasSlotController(this, "avatar");
    this.firstName = "";
    this.lastName = "";
  }
  firstUpdated() {
    this.handleProfileDataChange();
  }
  handleAvatarChange() {
    this.hasAvatar = !!(this.hasSlot.test("avatar") || this.avatarImage);
  }
  handleProfileDataChange() {
    var _a;
    Object.assign(this, this.profileData);
    this.addProfileCardItems((_a = this.profileData) == null ? void 0 : _a.items);
    this.handleAvatarChange();
  }
  addProfileCardItems(items) {
    if (!items)
      return;
    items.forEach((element) => {
      const profileCardItem = document.createElement("fadv-profile-card-item");
      if (element.name)
        profileCardItem.name = element.name;
      if (element.value)
        profileCardItem.innerHTML = element.value;
      if (element.highlighted)
        profileCardItem.setAttribute("highlighted", "true");
      this.append(profileCardItem);
    });
  }
  renderAvatar() {
    if (!this.hasSlot.test("avatar") && !this.avatarImage)
      return w;
    const label = `${this.firstName} ${this.lastName}`;
    const initials = this.firstName[0] + this.lastName[0];
    return $`<fadv-avatar image=${this.avatarImage} initials=${initials} label=${label}></fadv-avatar></slot>`;
  }
  renderButton() {
    if (!this.profileUrl)
      return w;
    return $`<fadv-button variant="monochrome" size="small" outline>${t2("components:profileCard.viewProfile")}</fadv-button>`;
  }
  renderBadge() {
    if (!this.status)
      return w;
    return $`<fadv-box pv="xx-small" mv="xxx-small" display="inline-block"><fadv-badge variant=${this.variant} size="large" pill>${this.status}</fadv-badge></fadv-box>`;
  }
  render() {
    return $`<div part="base" class=${o({
      "profile-card": true,
      "profile-card--has-badge": !!this.status,
      "profile-card--has-avatar": !!this.hasAvatar
    })} ><slot name="avatar" @slotchange=${this.handleAvatarChange}>${this.renderAvatar()}</slot><fadv-typography type="heading-x-small" weight="500">${this.firstName} ${this.lastName}</fadv-typography><div class="profile-card__items">${this.renderBadge()}<fadv-box pt="small" display="inline-block">${this.renderButton()}</fadv-box></div><slot></slot></div>`;
  }
};
FadvProfileCard.styles = profile_card_styles_default;
__decorateClass([
  i(".profile-card")
], FadvProfileCard.prototype, "profileCardItem", 2);
__decorateClass([
  e()
], FadvProfileCard.prototype, "status", 2);
__decorateClass([
  e()
], FadvProfileCard.prototype, "variant", 2);
__decorateClass([
  e({ attribute: "first-name" })
], FadvProfileCard.prototype, "firstName", 2);
__decorateClass([
  e({ attribute: "last-name" })
], FadvProfileCard.prototype, "lastName", 2);
__decorateClass([
  e({ attribute: "profile-data", converter: jsonAttributeConverter })
], FadvProfileCard.prototype, "profileData", 2);
__decorateClass([
  e({ attribute: "avatar-image" })
], FadvProfileCard.prototype, "avatarImage", 2);
__decorateClass([
  e({ attribute: "profile-url" })
], FadvProfileCard.prototype, "profileUrl", 2);
__decorateClass([
  t()
], FadvProfileCard.prototype, "hasAvatar", 2);
__decorateClass([
  watch("profileData", { waitUntilFirstUpdate: true })
], FadvProfileCard.prototype, "handleProfileDataChange", 1);
FadvProfileCard = __decorateClass([
  n("fadv-profile-card")
], FadvProfileCard);

export {
  FadvProfileCard
};
